import { useEffect, useRef } from "react";
import Webcam from "react-webcam";

const QrReader = ({ onScan }) => {
    const camRef = useRef(null);

    useEffect(() => {
        const timer = setInterval(() => {
            capture();
        }, 500);
        return () => clearInterval(timer);
    }, []);

    const videoConstraints = {
        width: 300,
        height: 300,
        facingMode: "environment"
    };

    const capture = () => {
        const qrSrc = camRef.current.getScreenshot();
        onScan(qrSrc);
    }

    return (
        <div>
            <Webcam
                audio={false}
                ref={camRef}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
                onClick={() => capture() }
            />
        </div>
    );
}

export default QrReader;